import axios from 'axios'
import instance from './Axios'
import { adminAPI } from './Axios'

const setAuthToken = (token) => {
  if (token) {
    // Apply authorization token to every request if logged in
    axios.defaults.headers.common['Authorization'] = token
    instance.defaults.headers.common['Authorization'] = token
    adminAPI.defaults.headers.common['Authorization'] = token
  } else {
    // Delete auth header
    delete axios.defaults.headers.common['Authorization']
    delete instance.defaults.headers.common['Authorization']
    delete adminAPI.defaults.headers.common['Authorization']
  }
}

export default setAuthToken
